// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import qs from "qs";
Vue.config.productionTip = false;
import StarRating from "vue-star-rating";
import "es6-promise/auto";
var VueTruncate = require("vue-truncate-filter");
Vue.use(VueTruncate);
Vue.component("star-rating", StarRating);
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);
import Toasted from "vue-toasted";
Vue.use(Toasted, { duration: 5000, position: "bottom-right" });
const moment = require("moment");
import { store } from './store/store'
Vue.use(require("vue-moment"), { moment });
import SortedTablePlugin from "vue-sorted-table";
Vue.use(SortedTablePlugin);

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
Vue.use(Loading);

import BootstrapVue from "bootstrap-vue";

Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import VModal from 'vue-js-modal'
Vue.use(VModal, { dynamic: true })
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: "UA-159906134-1",
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,store,
  components: { App },
  template: "<App/>"
});
console.log(process.env.NODE_ENV)
Vue.prototype.src =
  process.env.NODE_ENV === "production"
    ? "https://popcon21.s3.ap-northeast-2.amazonaws.com/media/"
    : "https://popcon21.s3.ap-northeast-2.amazonaws.com/media/";
Vue.prototype.qs = qs.stringify;
Vue.prototype.$http = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "http://popcontents.com/api/"
      : "http://localhost:8001/api/"
  // headers: {
  //   "Content-Type": "application/x-www-form-urlencoded",
  //   Accept: "application/json"
  // }
});
Vue.prototype.$http.interceptors.response.use(
  function(r) {
    try {
      if (r.headers.expires && r.headers.expires.indexOf("GMT") === -1)
        localStorage.setItem("expires", r.headers.expires);
    } catch (e) {
      console.log(e);
    }
    return r;
  },
  function(e) {
    try {
      if (localStorage.getItem("login") == "true" && e.response.status == 401) {
        // 자동 로그아웃 조건
        // 1. 클라이언트에서 유저가 로그인 상태인데
        // 2. 서버에서 온 응답이
        // 3. 401(권한) 없음 일때
        localStorage.removeItem("id");
        localStorage.removeItem("login");
        localStorage.removeItem("session_key");
        localStorage.removeItem("expires");

        alert("로그아웃 되었습니다.");
        //Vue.$router.push("/")
        location.href = "/";
      }
    } catch (e) {
      console.log(e);
    }
  }
);

Vue.prototype.$http.defaults.params = {};
Vue.prototype.$http.defaults.headers.common[
  "Authorization"
] = localStorage.getItem("session_key")
  ? localStorage.getItem("session_key")
  : "";

Vue.prototype.$http.defaults.params["session_key"] = localStorage.getItem(
  "session_key"
)
  ? localStorage.getItem("session_key")
  : "";



// WEBPACK FOOTER //
// ./src/main.js